<template title="预约详情页-用户">
	<div class="contentHome">
		<div class="centerPage">
			<tabCommon></tabCommon>
			<div class="right">
				<el-breadcrumb separator-class="el-icon-arrow-right" class="title">
					<el-breadcrumb-item>
						<a href="javascript:void(0);" @click="$router.push('/user/counsel')"
							class="aHref">心理咨询</a>
					</el-breadcrumb-item>
					<el-breadcrumb-item>咨询详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="formUserInfo">
					<div class="cnHomeTabsItem flex">
						<div class="avatar img" :style="'backgroundImage: url('+appoint.headImgPath+')'"></div>
						<div class="rightHome">
							<div class="flex">
								<span>医师：{{appoint.doctorName}}</span>
								<span>预约号：{{appoint.appointNo}}</span>
							</div>
							<p>
								<span class="time" style="width: unset">预约时间：{{appoint.appointDateShow}}</span>
								<span
									:class="(appoint.appointState===0&&appoint.payState===0)?'yellow'
										:appoint.appointState===1?'yellow'
										:appoint.appointState===2?'grey'
										:appoint.appointState===3?'green'
										:appoint.appointState===4?'green'
										:'cost'">
									<!--{{appoint.state==1?'待付款':appoint.state==2?'待咨询':'咨询完成'}}-->
									{{(appoint.appointState===0&&appoint.payState===0)?'待付款'
									:appoint.appointState===1?'待通话'
									:appoint.appointState===2?'已失效'
									:appoint.appointState===3?'待分析'
									:appoint.appointState===4?'已结束'
									:appoint.appointState===5?'已取消'
									:'有问题'}}
								</span>
							</p>
							<div class="flex">
								<span>咨询费用：<span class="cost">￥{{appoint.payAmount}}</span></span>
								<el-button v-if="appoint.appointState===0" size="mini" class="solid" @click="toPay(appoint.id)">
									去付款
								</el-button>
								<el-button v-if="appoint.appointState===1" size="mini" class="solid" @click="toConsult(appoint.id)">
									去咨询
								</el-button>
							</div>
						</div>
					</div>
					<div class="cnHomeTabsItem ">
						<p class="infoTit">预约信息</p>
						<div class="appointInfo">
							<p style="width: unset"><span>预约时间：</span>{{appoint.appointDateShow}}</p>
							<p><span>咨询方式：</span>{{appoint.consultMode===1?'语音':'视频'}}</p>
							<div class="flex">
								<p><span>真实姓名：</span>{{appoint.realName}}</p>
								<p><span>年龄：</span>{{appoint.age}}岁</p>
								<p><span>性别：</span>{{appoint.gender===1?'男': appoint.gender===1? '女': '-' }}</p>
							</div>
							<div class="flex">
								<p><span>所在城市：</span>{{appoint.abodeCity}}</p>
								<p><span>职业：</span>{{appoint.occupation}}</p>
							</div>
							<!--<div class="flex">
								<p><span>手机号码：</span>{{appoint.mobile}}</p>
								<p><span>邮箱账号：</span>{{appoint.email}}</p>
							</div>-->
							<p class="text"><span>问题描述：</span><span>{{appoint.problemDesc}}</span></p>
							<p class="text"><span>期望效果：</span><span>{{appoint.expectEffect}}</span></p>
						</div>
					</div>

					<div class="cnHomeTabsItem" v-if="appointFileList.length !== 0">
						<p class="infoTit">附件</p>
						<div class="appointInfo" style="padding-left: 30px;">
							<p v-for="appointFile in appointFileList" :key="appointFile.id" class="attachedFile">
								<a href="javascript:void(0)" @click="downloadFile(appointFile.id)">{{appointFile.fileName}}
									<span>下载</span></a>
							</p>
						</div>
					</div>

					<div class="cnHomeTabsItem " v-if="record">
						<p class="infoTit">分析结果</p>
						<div class="appointInfo">
							<p><span>分析结果：</span>{{record.result}}</p>
							<p class="text"><span>建议：</span><span>{{record.adviseWritten}}</span></p>
							<p><span>医院建议：</span>{{record.adviseHospital}}</p>
							<p><span>医师建议：</span>{{record.adviseDoctor}}</p>
							<p><span>用药建议：</span>{{record.adviseDrug}}</p>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
  import base from '@/api/common';

  export default {
    name: "phyDetail",
    data() {
      return {
        eventContent: '',
        appoint: {},
        record: {},

        appointFileList: []
      }
    },
    inject: ['reload'],
    components: {
      'tabCommon': () => import('./tabCommon'),
    },
    beforeMount() {
      this.getData();

      // 附件
      let id = this.$route.params.id;
      this.$ajax.get(base.basePath + 'medical/medical-appoint-file/authorize/list/' + id).then(res => {
        if (res.data.status === 'success') {
          this.appointFileList = res.data.list;
        }
      })
    },
    mounted() {
    },
    methods: {
      getData() {
        let id = this.$route.params.id;
        let vm = this;
        vm.$ajax.get(base.api.user.appointDetail.replace('{id}', id))
          .then((res) => {
            if (res.data.status === 'success') {
              res.data.data.appoint.appointDateShow = base.utils.buildShowDate(res.data.data.appoint.appointStartLongtime, res.data.data.appoint.appointEndLongtime);
              // if (res.data.data.appoint.payState == 0) {
              //     res.data.data.appoint.state = 1;
              // } else if (res.data.data.appoint.payState == 1 && res.data.data.appoint.appointState == 1) {
              //     res.data.data.appoint.state = 2;
              // } else if (res.data.data.appoint.payState == 1 && res.data.data.appoint.appointState == 4) {
              //     res.data.data.appoint.state = 3;
              // }

              vm.appoint = res.data.data.appoint;
              vm.record = res.data.data.record;
            } else {
              // vm.$message.error(res.data.message);
              vm.$router.back();
            }
          })
      },
      toPay(id) {
        this.$router.push('/user/order/' + id)
      },
      toConsult(id) {
        this.$router.push('/chat/' + id)
      },
      downloadFile(fileId) {
        this.$ajax.post(base.api.upload.token.appoint.replace("{id}", fileId)).then(res => {
          if (res.data.status === 'success') {
            location.href = base.api.upload.download.token.replace("{token}", res.data.token);
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('获取文件失败');
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import "../../assets/css/personalCenter.scss";

	p.attachedFile {
		width: 90%;

		a {
			color: #303139;

			span {
				color: #4395FF;
				margin-left: 10px;
				font-weight: 700;
				width: unset;
			}
		}
	}
</style>
